<script>
  import { Line } from 'vue-chartjs'

  export default {
    extends: Line,
    props: ['labels', 'dataset'],
    watch: { 
      labels: function(labels) {
        this.renderChart(this.data, this.options);
      }
    },
    computed: {
      options: function() {
        return {
          maintainAspectRatio: false,
          layout: {
            padding: {
              right: 15,
              top: 20
            }
          },
          tooltips: {
            titleFontSize: 16,
            bodyFontSize: 14,
            displayColors: false,
            xPadding: 10,
            yPadding: 10,
            callbacks: {
              label: function(tooltipItem, data) 
              { 
                var label = data.datasets[tooltipItem.datasetIndex].label+': ' || '';
                return label+tooltipItem.yLabel+' мс';
              }
            }
          },
          legend:
          {
            display: false,
            labels:
            {
              display: false
            }
          },
          scales:
          {
            yAxes: [
            {
              stacked: true,
              gridLines:
              {
                display: true,
                color: "#e6e6e6",
                borderDash: [2, 2],
                lineWidth: 2,
                drawBorder: false,
              },
              ticks:
              {
                fontSize: 14,
                fontColor: '#B5B5B5',
                display: true,
                // max: Math.floor(Math.max(...Object.values(this.dataset)) * 1.1 / 5) * 5 + 5
              }
            }],
            xAxes: [
            {
              stacked: true,
              gridLines:
              {
                display: true,
                color: "#e6e6e6",
                borderDash: [2, 2],
                lineWidth: 2,
                drawBorder: false,
              },
              ticks:
              {
                callback: function(tick, index, array) 
                {
                  return (index % 2) ? "" : tick;
                },
                autoSkip: true,
                maxRotation: 0,
                minRotation: 0,
                fontSize: 14,
                fontColor: '#B5B5B5',
              }
            }]
          },
          chartArea: {
            backgroundColor: 'rgba(251, 85, 85, 0.4)'
          }
        };
      },
      data: function() {
        return {
          labels: this.labels,
          datasets: [
          {
            label: "Время ответа",
            fill: true,
            backgroundColor: 'rgb(136,106, 181, 0.1)',
            borderColor: '#886AB5',
            data: this.dataset
          }]
        };
      }
    },
    mounted () {
      this.renderChart(this.data, this.options)
    }
  }
</script>